import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'components/notifications/Modal';
import { Button } from 'components/buttons/Button';
import { FormCheckbox } from 'components/form-fields/FormCheckbox';

export function TyreCheckSignOffModal({ isOpen, onClose, onSignOff }) {
    const [isChecked, setIsChecked] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };

    const handleSignOff = async () => {
        if (!isChecked) {
            alert('Please confirm by checking the box before signing off.');
            return;
        }

        setLoading(true);
        try {
            await onSignOff(); // Call the prop function
            onClose();         // Close modal after sign-off
        } finally {
            setLoading(false);
        }
    };

    const footer = (
        <div
            className="modal-footer-actions"
            style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '1rem', // Adjust spacing between buttons
                marginTop: '1rem',
            }}
        >
            <Button
                text="Cancel"
                intent="secondary"
                onClick={onClose}
            />
            <Button
                text="Sign Off"
                icon="tick"
                intent="secondary"
                onClick={handleSignOff}
                disabled={!isChecked}
                loading={loading}
            />
        </div>
    );

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Sign Off Defect"
            footer={footer}
            size="medium"
            className="defect-signoff-modal"
        >
            <FormCheckbox
                checked={isChecked}
                onChange={handleCheckboxChange}
                label="I consider that the defects have been rectified satisfactorily and these vehicles are now in a safe and roadworthy condition."
            />

            <span>
                <strong>Note:</strong> It is always the responsibility of the operator that a vehicle is in a roadworthy condition before being used on the road.
            </span>

        </Modal>
    );
}

TyreCheckSignOffModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSignOff: PropTypes.func.isRequired
};

export default TyreCheckSignOffModal;

